import React, { useState, useEffect } from "react"
import $ from "jquery"
import "./Impressao.css"
import HTML from 'html-react-parser';
import { List } from "react-bootstrap-icons";
import BuscaAPI from "../Util/BuscaAPI";

import { useReactToPrint } from "react-to-print";
import { useRef } from "react";
import Print from "../Print";
import { LocalData } from "../../Componentes/Util/LocalData"
//import html2pdf from "html2pdf.js"

const Impressao = ({Lista, AtualizaContador}) => {
    const [prodEscolhidos, setProdEscolhidos] = useState([]);
    const [paginacaoPRODs, setPaginacaoPRODs] = useState([]);
    const [PROD, setPROD] = useState([]);
    const [localdataPROD, setLocaldataPROD] = useState([]);

    const [qtdPRODsFolha, setQtdPRODsFolha] = useState(12);
    const [widthProduto, setWidthProduto] = useState(150);
    const [heighProduto, setHeightProduto] = useState(240);
    const [widthIMGProduto, setWidthIMGProduto] = useState(150);
    const [heightIMGProduto, setHeightIMGProduto] = useState(150);
    const [fontSizeTituloProduto, setFontSizeTituloProduto] = useState(14);

    const [capa, setCapa] = useState([]);
    const [quartaCapa, setQuartaCapa] = useState([]);
    // const componentRef = useRef(null);
    // const handlePrint = useReactToPrint({
    //     content: () => componentRef.current
    //     print: async (printIframe) => {
    //         const document = printIframe.contentDocument;
    //         if (document) {
    //             const html = document.getElementsByClassName("App")[0];
    //             const options = {
    //             margin: 0,
    //             filename: "the-joys-of-buying-over-building.pdf",
    //             jdPDF: { unit: "mm", format: "a4", orientation: "portrait" }
    //             };
    //             const exporter = new Html2Pdf(html, options);
    //             await exporter.getPdf(options);
    //         }
    //     },
    // });
    //const [totalPaginasImpressao, setTotalPaginasImpressao] = useState(0);
    //console.log("localdataPROD", localdataPROD);
    useEffect(() => {
        const Itens = async (e) => {
            $("#objCarregaTela").addClass("display-block");  
            try{
            // console.log(LocalData.get("prodID"));
            try{   
                if(LocalData.get("prodID") !== "")
                    Lista = JSON.parse(LocalData.get("prodID"));
                    //setLocaldataPROD(JSON.parse(LocalData.get("prodID")));
            }catch(error){}
            //alert(Lista);
            //if(!localdataPROD) setLocaldataPROD(Lista);

            //setPROD(await BuscaAPI('http://178.156.175.191:3001/api/produtos'));
            //setPROD(await BuscaAPI('http://localhost:3001/api/produtos'));
            setPROD(await BuscaAPI('https://api.construmarcas.com.br/api/produtos'));
            setCapa(await BuscaAPI('https://api.construmarcas.com.br/api/produtos/!!CAPA!!'));
            setQuartaCapa(await BuscaAPI('https://api.construmarcas.com.br/api/produtos/!!QUARTA-CAPA!!'));
            
            //pega todas as informações dos produtos, baseado nos IDs escolhidos e guardados no cache (LocalData)
            let _PRODs_escolhidos = PROD.filter((b) => {
                return Lista.filter(a => b.identificador == a).length > 0;
            });  
            setProdEscolhidos(_PRODs_escolhidos);    
            //console.log("_PRODs_escolhidos",_PRODs_escolhidos);

            /************************************************** */
            let arrPRODsCategorizados=[];
            _PRODs_escolhidos.forEach((categoria) => {
                //console.log("###", JSON.parse(categoria.dados).arvoreCategoria[0].descricaoCompleta);
                arrPRODsCategorizados.push({nome: JSON.parse(categoria.dados).nome, descricaoCompleta:JSON.parse(categoria.dados).arvoreCategoria[JSON.parse(categoria.dados).arvoreCategoria.length-1].descricaoCompleta, ...categoria});
            });          

            //primeiro, ordena por nome e depois por descrição completa
            arrPRODsCategorizados.sort((a, b) => a.nome.localeCompare(b.nome)); 
            arrPRODsCategorizados.sort((a, b) => a.descricaoCompleta.localeCompare(b.descricaoCompleta));
            //console.log("arrPRODsCategorizados", arrPRODsCategorizados);
            /************************************************** */

            let totalPaginasImpressao = Math.floor((arrPRODsCategorizados.length/qtdPRODsFolha) + ((arrPRODsCategorizados.length % qtdPRODsFolha) > 0 ? 1 : 0));
            //let totalPaginasImpressao = Math.floor((_PRODs_escolhidos.length/qtdPRODsFolha) + ((_PRODs_escolhidos.length % qtdPRODsFolha) > 0 ? 1 : 0));
            let arrPaginacao = [];
            for(let i=1;i<=totalPaginasImpressao;i++){
                //arrPaginacao[i] = PaginacaoItens(_PRODs_escolhidos, i, qtdPRODsFolha, (i==(totalPaginasImpressao)) ? _PRODs_escolhidos.length % qtdPRODsFolha : qtdPRODsFolha);
                arrPaginacao[i] = PaginacaoItens(arrPRODsCategorizados, i, qtdPRODsFolha, (i==(totalPaginasImpressao)) ? arrPRODsCategorizados.length % qtdPRODsFolha : qtdPRODsFolha);
            }
            setPaginacaoPRODs(arrPaginacao);    
            }catch(error){}
            
            $("#objCarregaTela").removeClass("display-block");  
        }
        Itens();
    }, [Lista, qtdPRODsFolha, localdataPROD]);

    // function AlteraLista(_lista){
    //     Lista = _lista;
    //     console.log(("####", Lista, _lista));
    // }

    const evFecharImpressaoProduto = () => {
        $(".area-impressao-produto").removeClass("selecionado");
        $(".area-produto").removeClass("produto-selecionado");

        $("body").removeClass("overflow-hidden");
    }
    $(".area-impressao-produto").off().on("transitionend", fcFimAnimacao);
    function fcFimAnimacao(e) {      
        //if(!$(e.currentTarget).hasClass("selecionado"))
            //setLocaldataPROD(JSON.parse(LocalData.get("prodID")));
            //console.log(JSON.parse(LocalData.get("prodID")));
        // console.log("fim da animação");
        // if(!$(e.currentTarget).hasClass("selecionado"))
        //     $(".area-impressao-produto > .conteudo").html("");
    }
    
    // if(Lista.length > 0) {
    //     $(".lista-de-desejos").addClass("marcador");
    //     $(".lista-de-desejos .contador").val(Lista.length);
    // }
    // else
    //     $(".lista-de-desejos").removeClass("marcador");

    // if(prodEscolhidos.length > 0) {
    //     $(".lista-de-desejos").addClass("marcador");

    //     if($(".lista-de-desejos .contador").length === 0)
    //         $(".lista-de-desejos").prepend(`<div class="contador">${prodEscolhidos.length}</div>`);       
    // }
    // else
    //     $(".lista-de-desejos").removeClass("marcador");

    const contentRef = useRef(null);
    const reactToPrintFn = useReactToPrint({contentRef,
        // print: async (printIframe) => {
        //     const document = printIframe.contentDocument;
        //     if (document) {
        //         const html = document.getElementsByClassName("App")[0];
        //         const options = {
        //         margin: 0,
        //         filename: "the-joys-of-buying-over-building.pdf",
        //         jdPDF: { unit: "mm", format: "a4", orientation: "portrait" }
        //         };
        //         const exporter = new html2pdf(html, options);
        //         await exporter.getPdf(options);
        //     }
        // },
    });

    function PaginacaoItens(items, atual, limite, sobra){
        //console.log(items, atual, limite, sobra);
        let resultado = [];
        let totalPaginas = Math.ceil(items.length / limite);
        let contador = (atual * limite) - limite;
        //console.log("contador",contador, parseInt(limite), parseInt(sobra));
        let delimitador = contador + (parseInt(limite) >= parseInt(sobra) && parseInt(sobra) > 0 ? parseInt(sobra) : parseInt(limite));
        //console.log("delimitador",delimitador);
        //console.log("########: ", totalPaginas, contador, delimitador);
        //console.log("###", sobra, contador, delimitador);
        if(atual <= totalPaginas){
            for(let i=contador; i<delimitador; i++){
                //console.log("iiii: ", i);
                resultado.push(items[i]);
                contador++;
            }
        }

        return resultado;
    }

    const evCliqueRemoveProduto = (e) => {
        e.preventDefault();
        //alert($(e.currentTarget).parent().parent().attr("identificador"));
        let arrNovo = JSON.parse(LocalData.get("prodID")).filter(item => item !== parseInt($(e.currentTarget).attr("identificador")));
        $(`.lista-produtos-categoria .capa[id='${parseInt($(e.currentTarget).attr("identificador"))}'] .eu-quero-produto`).removeClass("marcado");
        //AlteraLista(arrNovo);
        setLocaldataPROD(arrNovo);
        //alert("localdataPROD: " + localdataPROD);
        AtualizaContador(arrNovo);
        //alert(JSON.stringify(arrNovo));
        LocalData.set("prodID", JSON.stringify(arrNovo));
    }

    // console.log("capa", JSON.parse(capa[0].dados).anexos[0].url);
    return (
        <div className="area-impressao-produto">
            {/* <ReactToPrint
                trigger={() => <button>Print this out!</button>}
                content={() => componentRef.current}
            /> */}
            {/* <button onClick={() => handlePrint}>Print article</button> */}
            <div className="btn-fechar-impressao-produto" onClick={evFecharImpressaoProduto}>X</div>
            <div className="conteudo">
                <div className="config-impressao">
                    <button onClick={() => reactToPrintFn()}>Imprimir</button>
                    {/* <div className="config-01"><span className="rotulo">Qtd de produtos por página:</span><br /><input type="number" value={qtdPRODsFolha} placeholder="12" min={1} id="qtd-PRODs-pagina" onChange={(e) => { $(e.currentTarget).val(e.target.value); setQtdPRODsFolha(e.target.value); }} /></div> */}
                    <div className="config-01"><span className="rotulo">Qtd de produtos por página:</span><br />12</div>
                    <div className="config-02"><span className="rotulo">Tamanho do título (px):</span><br /><input type="number" value={fontSizeTituloProduto} placeholder="14" min={1} id="font-size-prod" onChange={(e) => { setFontSizeTituloProduto(e.target.value); $(":root").css("--font-size-titulo-produto", fontSizeTituloProduto +"px");  $(".pagina .produto").css("font-size", fontSizeTituloProduto +"px"); }} /></div>
                    <div className="config-03">
                        <span className="rotulo">Largura do produto (px):</span><br /><input type="number" value={widthProduto} placeholder="150" min={1} id="width-produto" onChange={(e) => { $(":root").css("--width-produto",$(e.currentTarget).val()+"px"); setWidthProduto(e.target.value);  $(".pagina .produto").css("width", widthProduto +"px"); }} />
                        <br /><span className="rotulo">Altura do produto (px):</span><br /><input type="number" value={heighProduto} placeholder="210" min={1} id="height-produto" onChange={(e) => { $(":root").css("--height-produto",$(e.currentTarget).val()+"px"); setHeightProduto(e.target.value); $(".pagina .produto").css("height", heighProduto +"px"); }} />
                    </div>
                    <div className="config-04">
                        <span className="rotulo">Largura da imagem (px):</span><br /><input type="number" value={widthIMGProduto} placeholder="150" min={1} id="width-img-produto" onChange={(e) => { $(":root").css("--width-img-produto",$(e.currentTarget).val()+"px"); setWidthIMGProduto(e.target.value); $(".pagina .produto > div").css("width", widthIMGProduto +"px"); }} />
                        <span className="rotulo">Altura da imagem (px):</span><br /><input type="number"  value={heightIMGProduto} placeholder="150" min={1} id="height-img-produto" onChange={(e) => { $(":root").css("--height-img-produto",$(e.currentTarget).val()+"px"); setHeightIMGProduto(e.target.value); $(".pagina .produto > div").css("height", heightIMGProduto +"px"); }} />
                    </div>
                    <button onClick={() => {
                        let arrNovo = [];
                        $(`.lista-produtos-categoria .capa .eu-quero-produto`).removeClass("marcado");
                        setLocaldataPROD(arrNovo);
                        AtualizaContador(arrNovo);
                        LocalData.set("prodID", JSON.stringify(arrNovo));
                        
                    }}>REMOVER TODOS OS ITENS</button>
                </div>
                {/* <Print></Print> */}
                <div ref={contentRef} className="lista-de-produtos-impressao">
                    {
                        (capa.length > 0 && capa[0].dados !== null && capa[0].dados !== "null" && capa[0].dados !== "undefined") &&
                        <div className="pagina CapaCatalogo" /*style={{"background":`url(${JSON.parse(capa[0].dados).anexos[0].url})`}}*/>
                            <img src={JSON.parse(capa[0].dados).anexos[0].url} alt="Construmarcas, qualidade garantida em todos os nossos produtos." />
                            {/* <div className="CapaCatalogo display-none">
                                <img src={JSON.parse(capa[0].dados).anexos[0].url} alt="Construmarcas, qualidade garantida em todos os nossos produtos." />
                            </div> */}
                        </div>
                    }
                    {   
                        (paginacaoPRODs.length > 0) ?  
                            paginacaoPRODs.map((p, pi) => {
                                //let _cat = "";
                                return <div key={pi} className="pagina">
                                    <div className="cabecalho"><img alt="Construmarcas, qualidade garantida em todos os nossos produtos." src="/imagens/Impressao/cabecalhoImpressao.jpg" /></div>
                                    <div className="produtos">
                                        {
                                            p.map((a, ai) => {
                                                // //let vdd = a.descricaoCompleta == _cat;
                                                // //_cat = a.descricaoCompleta;
                                                
                                                /***********************************/
                                                // let nomeCategoria = "";
                                                // let corCategoria = "";
                                                // //console.log(nomeCategoria, " --- ", a.descricaoCompleta);
                                                // try{
                                                //     let montaNome = a.descricaoCompleta.split(">");
                                                //     montaNome[0].split("!")[0].trim();
                                                //     nomeCategoria = montaNome.concat(" ").join(">").trim();
                                                //     console.log("nomeCategoria", nomeCategoria);

                                                //     corCategoria = a.descricaoCompleta.split("!")[1].split(" ")[0];
                                                //     console.log("corCategoria", corCategoria);
                                                // }catch(error){}
                                                //console.log("a", a);
                                                //console.log("a.dados", JSON.parse(a.dados));
                                                return <div key={ai} className="produto" identificador={a.identificador}>
                                                        {
                                                            // (!vdd) && <div className="descricaoCategoria"><div className="rotulo">{a.descricaoCompleta}</div></div>
                                                        }
                                                        <div className="descricaoCategoria" /*style={{"backgroundColor":corCategoria}}*/>
                                                            <div className="rotulo">
                                                                {
                                                                    a.descricaoCompleta
                                                                    // nomeCategoria
                                                                }
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <div className="item" title={JSON.parse(a.dados).nome} style={{"background":`url(${(JSON.parse(a.dados).anexos && JSON.parse(a.dados).anexos.length > 0) ? JSON.parse(a.dados).anexos[0].url : ""})`}}>
                                                                <div title="Excluir item do catálogo" identificador={a.identificador} className="btn-excluir-produto" onClick={evCliqueRemoveProduto}>x</div>
                                                            </div>
                                                            <div className="nome-produto">
                                                                {
                                                                    JSON.parse(a.dados).nome
                                                                }
                                                            </div>
                                                            <span className="fim-de-folha"></span>
                                                        </div>
                                                    </div>
                                            })
                                        }
                                    </div>
                                    <div className="rodape"><img alt="Construmarcas, qualidade garantida em todos os nossos produtos." src="/imagens/Impressao/rodapeImpressao.jpg" /></div>
                                </div>
                            }) 
                        :   <div className="lista-produtos-vazia">
                                Você não tem iten(s) incluído(s) no catálogo.
                            </div>

                        // prodEscolhidos.map((a, index) => (
                        //     // console.log(JSON.parse(a.dados)),
                        //     <div key={index} className="produto">
                        //         <div style={{"background":`url(${JSON.parse(a.dados).anexos[0].url})`}}></div>
                        //         {
                        //             JSON.parse(a.dados).nome
                        //         }
                        //         <span className="fim-de-folha"></span>
                        //     </div>
                        // ))
                    }
                    {
                        (quartaCapa.length > 0 && quartaCapa[0].dados !== null && quartaCapa[0].dados !== "null" && quartaCapa[0].dados !== "undefined") &&
                        <div className="pagina quartaCapaCatalogo">
                            <img src={JSON.parse(quartaCapa[0].dados).anexos[0].url} alt="Construmarcas, qualidade garantida em todos os nossos produtos." />
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}

export default Impressao;